import cogoToast from "cogo-toast"
import React, { useEffect, useRef, useState } from "react"
import { SubHeader } from "../../Common/layout/SubHeader";
import { Button } from "react-bootstrap"
import { useDownloadKYCReportMutation } from "../../../../redux/apiSlice"
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../_metronic/_partials/controls"
import DynamicSimpleTable from "../../../util/DynamicSimpleReactTable"
import { errorMessage, formatDate, formatStatus, formatUsername, ucFirst } from "../../../util/Helpers"
import { ViewIcon } from "../../../util/Icons"
import { Permissions, PermissionType } from "../../../util/Permissions"
import { FilterGroup } from "../../Common/components/FilterGroup"
import { Permission } from "../../Common/layout/Permission"
import ViewKycModal from "./modal/ViewKycModal"

export const VerifiedPendingDocument = ({ match: { params: { userGroup} } }) => {
    const tableRef = useRef();
    const [
        downloadKYCReport,
        {
            isLoading: isLoadingReport,
            isSuccess: isReportGenerating,
            error: errorReport,
        }
    ] = useDownloadKYCReportMutation()

    useEffect(() => {
        if (errorReport) {
            cogoToast.error(errorReport.data);
        }
    }, [errorReport])

    useEffect(() => {
        if (isReportGenerating) {
            cogoToast.success(`KYCs export in progress. The resulting file will be sent to your mail.`);
        }
    }, [isReportGenerating])

    const [kycModal, setKycModal] = useState({ showKycModal: false, userId: null, action: null });

    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setKycModal({ ...kycModal, [modal]: !kycModal[modal] })
    }

    /* Action Buttons */
    const pendingKycView = row => {

        return (
            <span style={{ whiteSpace: "nowrap" }}>
                <Button
                    title="View KYC"
                    className="btn btn-icon btn-light btn-hover-primary btn-sm  bg-white"
                    onClick={_ => setKycModal({ ...kycModal, showKycModal: true, userId: row.userId, action: row.action })}
                >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                        <ViewIcon />
                    </span>
                </Button>
            </span>
        )
    }

    return (
        <div className="py-4 px-6">
            <FilterGroup key={`kyc-${userGroup}`} defaultFilters={{ "sortBy": "updatedAt:desc"}}>
                <SubHeader>
                        <SubHeader.Nav>
                            <SubHeader.NavItem label={"Pending"} to={`/pending-kyc/${userGroup}/pending`} />
                            <SubHeader.NavItem label={"Verified With Pending Document"} to={`/pending-kyc/${userGroup}/level-two-verified`} />
                        </SubHeader.Nav>
                    </SubHeader>
            <FilterGroup.DateRange className={"mb-5 mt-8"} />
            <FilterGroup.Content>
                {
                    ({ filters }) => (
                        <Card>
                            <CardHeader title={`Verified With Pending Document KYCs`}>
                                <CardHeaderToolbar>

                                    <div style={{ marginLeft: '10px' }}></div>

                                    <FilterGroup.Filter className={"bg-black"} width="300px" name={"sortBy"} label={"Sort"} menuAnchorRight>
                                        <FilterGroup.Option value={"updatedAt:desc"}>Updated At ( Descending )</FilterGroup.Option>
                                        <FilterGroup.Option value={"updatedAt:asc"}>Updated At ( Ascending )</FilterGroup.Option>
                                        <FilterGroup.Option value={"completion:desc"}>Completion Percentage ( Descending )</FilterGroup.Option>
                                        <FilterGroup.Option value={"completion:asc"}>Completion Percentage ( Ascending )</FilterGroup.Option>
                                    </FilterGroup.Filter>

                                    <div style={{ margin: '10px' }}></div>

                                    <Permission permission={Permissions.REPORTS} permissionType={PermissionType.CREATE}>
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            disabled={isLoadingReport}
                                            onClick={() => downloadKYCReport({
                                                userGroup,
                                                startDate: filters?.startDate || "",
                                                endDate: filters?.endDate || "",
                                                format: "csv",
                                            })}
                                        >
                                            Export CSV
                                        </button>
                                    </Permission>

                                </CardHeaderToolbar>
                            </CardHeader>
                            <CardBody>
                                <DynamicSimpleTable
                                    key={`verified-kyc-${userGroup}`}

                                    queryParams={
                                        `startDate=${filters?.startDate || ""}`
                                        + `&endDate=${filters?.endDate || ""}`
                                        + `&sortBy=${filters?.sortBy || ""}`
                                        + `&userType=${filters?.userType || ""}`
                                        + `&approvalType=${filters?.approvalType || ""}`
                                        + `&kycLevel=${filters?.kycLevel || 3}`
                                        + `&action=${filters?.action || "required"}`
                                        + `&status=verified`


                                    }
                                    source={{ url: `/pending-kyc/user-group/${userGroup}` }}
                                    columns={[
                                        {
                                            title: "NAME",
                                            format: row => formatUsername(row.userId, `${row.firstName} ${row.lastName}`)
                                        },
                                        { title: "EMAIL", key: "email" },
                                        { title: "PHONE", key: "phone" },
                                        {
                                            title: "LEVEL",
                                            format: row => {
                                                if (row.kycLevel === 3) {
                                                    return 2;
                                                } else if (row.kycLevel === 2 && row.status === "pending") {
                                                    return 1;
                                                } else {
                                                    return row.kycLevel;
                                                }
                                            }
                                        },
                                        {
                                            title: "STATUS",
                                            key: "status",
                                            format: row => {
                                                if (row.kycLevel === 2 && row.status === "pending") {
                                                    return formatStatus("verified");
                                                } else {
                                                    return formatStatus("pending_document");
                                                }
                                            }
                                        },
                                        {
                                            title: "ACTION",
                                            key: "action"
                                        },
                                        { title: "COMPLETION", format: row => `${row.completion}%` },
                                        { title: "UPDATED AT", format: row => formatDate(row.updated) },
                                        { title: "", format: pendingKycView }
                                    ]}

                                    ref={tableRef}
                                    onError={err => cogoToast.error(errorMessage(err))}
                                    refreshIcon={true}
                                />
                            </CardBody>
                        </Card>
                    )
                }
            </FilterGroup.Content>
        </FilterGroup>
            {
        kycModal.showKycModal &&
            <ViewKycModal {...{ ...kycModal, userGroup, tableRef }} onHide={toggleModal("showKycModal")} />
    }
        </div >
    )
}